import axios from '@/jslib/axios'

export const getGlobalOptions = params => {
  return axios({
    method: 'get',
    url: '/admin/options',
    params
  })
}
